import { backgroundColors, cardBackground } from './colors/background'
import { strokeColors } from './colors/stroke'
import { typographyColors } from './colors/typography'

export const colors = {
  // new theme
  ...typographyColors,
  ...backgroundColors,
  ...cardBackground,
  ...strokeColors,
  // old theme
  primary: '#E960AF',
  primaryAlt: '#FF85CB',

  secondary: '#F3BA2F',
  primaryDisabled: 'rgb(92, 47, 75)',

  normal: '#272f52',
  success: '#06C270',
  info: '#49a1b8',
  error: '#ED6A5E',
  warning: '#F3BF4F',

  background: '#16191f',
  backgroundAlt: '#191d25',
  backgroundAlt2: '#2b2f36',
  backgroundAlt3: '#22293d',
  backgroundAlt4: '#212947',
  backgroundAlt5: 'rgba(255, 255, 255, 0.04)',
  backgroundAlt6: 'rgb(22, 28, 36)',
  backgroundAlt7: 'rgba(35, 44, 61, 0.2)',
  backgroundAlt8: 'rgba(255, 255, 255, 0.08)',
  backgroundAlt9: 'rgb(25, 29, 37)',
  backgroundAlt10: '#192029',
  backgroundAlt11: 'rgba(118,118,128,0.25)',
  backgroundAlt12: 'rgba(224, 224, 224, 1)',
  backgroundAlt13: '#12b76a',
  backgroundAlt14: 'rgba(255, 255, 255, 0.06)',
  backgroundAlt15: '#3c3c434c', // 3c3c43 rgba(60, 60, 67, 0.3)
  backgroundAlt16: '#7878801e', // rgba(120, 120, 128, 0.12)
  backgroundAlt17: '#ffffff1f', // rgba(255, 255, 255, 0.12)
  backgroundAlt18: '#78788033', // rgba(120, 120, 128, 0.2)
  backgroundAlt19: 'rgba(255, 255, 2556, 0.06)',
  backgroundAlt20: 'rgba(35, 44, 61, 0.20)',
  backgroundAlt21: '#FDEFF7',

  providerBackground: 'rgba(35, 44, 61, 0.6)',
  backgroundToggle: '#808080',
  backgroundCashBack: 'rgba(22, 25, 31, 1)',
  backgroundAvatar: '#ccc1f0',
  backdrop: 'rgba(0, 0, 0, 0.49)',

  // Gradient
  gradient: {
    primary: 'linear-gradient(271.18deg, rgb(243, 198, 34) -54.06%, rgb(249, 83, 198) 83.78%)',
    primaryAlt: 'linear-gradient(180deg, #FF85CB 43.35%, #E960AF 138.04%)',
    primaryAlt1:
      'linear-gradient(90deg, rgb(216, 105, 254) 3.13%, rgb(220, 179, 179) 56.35%, rgb(229, 159, 206) 102.34%)',
    secondary: 'linear-gradient(270deg, #e960af -10.61%, #f3c622 112.88%)',
    tertiary: 'linear-gradient(126.03deg, rgb(249, 83, 198) 19.96%, rgb(243, 198, 34) 167.68%)',
    hover: 'linear-gradient(90deg, rgba(255, 255, 255, 0.08) 1.89%, rgba(255, 255, 255, 0) 108.73%)',
    aqua: 'linear-gradient(225deg, #0b94fe 7.55%, #00c4ee 50.47%, #0b94fe 92.5%)',
    aquaAlt:
      'linear-gradient(225deg, rgba(11, 148, 254, 0.20) 7.55%, rgba(0, 196, 238, 0.20) 50.47%, rgba(11, 148, 254, 0.20) 92.5%)',
  },

  // Text
  text: '#fff',
  textDisable: '#484F5D',
  textSubtle: '#ADADAD',
  textTertiary: '#E0E0E0',
  textHighlight: '#F3C622',
  textAlt: 'rgb(170, 149, 133)',
  textAlt1: '#6C727E',
  textAlt2: '#FFD026',
  textAlt3: '#FAFAFA',
  textAlt4: 'rgba(173, 173, 173, 0.5)',
  textAlt5: '#7A7A7A',
  textAlt6: '#ebebf5',
  textAlt699: '#ebebf599', // rgba(235, 235, 245, 0.60)
  textAlt7: '#3c3c43',
  textAlt8: '#8E8E93',
  textAlt9: '#C7C7CC',

  // Stroke
  stroke: '#272f52',
  strokeAlt: '#5769B8',
  strokeAlt2: 'rgba(249, 83, 198, 0.37)',
  strokeAlt1: 'rgb(39, 47, 82)',
  strokeAlt3: '#1877F2',
  strokeAlt4: '#7A7A7A',
  strokeBlur: 'rgba(255, 255, 255, 0.16)',
  // Modal
  modalBackground: '#16191F',
  modalHeaderBackground: '#1D2533',

  // Button
  buttonBackground: 'linear-gradient(271.18deg, rgb(243, 198, 34) -54.06%, rgb(249, 83, 198) 83.78%)',
  buttonBackgroundAlt: 'rgb(233, 96, 175)',
  buttonBackgroundAlt2: '#232C3D',
  buttonBackgroundAlt3: '#252A33',
  buttonBackgroundAlt4: '#F879C2',

  // Card
  cardBackground: '#161c24',
  cardBackgroundAlt: '#2B2E36',

  // Input
  inputDefault: '#151B25',
  inputAlt: '#1B212E',
  inputPlaceHolder: '#7d7f85',
  inputBackground: '#191D25',
  inputBackgroundAlt: 'rgb(30, 18, 18)',
  inputBlur: 'rgba(35, 44, 61, 0.4)',

  scroll: '#adadad38',

  border: 'rgba(44, 46, 51, 1)',

  separator: '#2C2E33',
  borderSecondary: '#76768040', // rgba(118, 118, 128, 0.25)
  borderSecondHover: 'rgba(118, 118, 128, 0.5)', // rgba(118,118,128,0.5)

  borderTeritary: '#7676801e',

  toggleBackground: 'rgba(255,255,255,0.1)',
  toggleThumb: 'rgba(255,255,255,0.7)',
} as const
